module.exports = __webpack_public_path__ + "img/booking_cancel_icon.14bd409d.svg";